import { withTranslation } from "next-i18next";
import { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Offcanvas from "@components/core/Offcanvas";
import Button from "@components/core/Button";
import { getProductReviews } from "@utils/call-api/reviews-call";
import ProductReviewCard from "../../Shared/ProductReviewCard";

function ProductReviewsSharedPictureOffcanvas({
  selectedSharedPictureIndex,
  product,
  opened,
  close,
  t,
}) {
  const [reviews, setReviews] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);

  const swiperRef = useRef(null);

  const isNextPageAvailable = pagination.current_page < pagination.total_pages;

  async function getReviews(page) {
    if (loading) return;

    try {
      setLoading(true);
      const res = await getProductReviews(product.id, page, true);

      setPagination({ ...res.meta.pagination, productId: product.id });
      if (page === 1) {
        setReviews(res.data);
      } else {
        setReviews([...reviews, ...res.data]);
      }
    } finally {
      setLoading(false);
    }
  }

  function getNextPage() {
    if (!isNextPageAvailable) return;

    getReviews(pagination.next_page);
  }

  useEffect(() => {
    function getReviewsFirstPage() {
      if (!opened || product.id === pagination.productId) return;

      getReviews(1);
    }

    getReviewsFirstPage();
  }, [opened, product.id]);

  return (
    <Offcanvas
      title={t("product:community_pictures_title")}
      show={opened}
      onHide={close}
      placement="bottom"
    >
      <div className="shared-pictures-offcanvas-swiper-container">
        {!!reviews.length && (
          <div className="shared-pictures-offcanvas-swiper-content">
            <Button
              variant="ghost-dark"
              className="bg-white custom-prev"
              leftIconName="chevron-left"
            />
            <Button
              variant="ghost-dark"
              className="bg-white custom-next"
              leftIconName="chevron-right"
            />
            <Swiper
              className="shared-pictures-offcanvas-swiper"
              modules={[Navigation]}
              spaceBetween={16}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              initialSlide={selectedSharedPictureIndex}
              onReachEnd={getNextPage}
              navigation={{
                nextEl: ".custom-next",
                prevEl: ".custom-prev",
              }}
              breakpoints={{
                0: {
                  slidesPerView: reviews.length < 2 ? 1 : 1.15,
                  navigation: {
                    enabled: false,
                  },
                },
                768: {
                  slidesPerView: 1,
                  navigation: {
                    enabled: true,
                  },
                },
              }}
            >
              {reviews.length ? (
                reviews.map((review) => (
                  <SwiperSlide key={review.id}>
                    <ProductReviewCard
                      review={review}
                      className="shared-picture-offcanvas"
                    />
                  </SwiperSlide>
                ))
              ) : (
                <SwiperSlide key="review-skeleton">
                  <ProductReviewCard
                    review={{}}
                    className="shared-picture-offcanvas"
                  />
                </SwiperSlide>
              )}
            </Swiper>
          </div>
        )}
      </div>
    </Offcanvas>
  );
}

export default withTranslation("product")(ProductReviewsSharedPictureOffcanvas);
